const USER_DATA = '@baseproject/user';

export default USER_DATA;
